// apps/web/src/components/analytics/decide/TopVictimCountriesPanel.tsx
//
// P8a Decide tab — top-N victim countries last 7d, gated on
// geoSufficiency. When geo signal is insufficient, renders the
// TopVictimSectorsPanel fallback inline.

import { useAnalyticsDecideTopVictimCountries } from '@/hooks/useAnalyticsDecideTopVictimCountries'
import { displayMapper } from '@/lib/display-mapper'
import { TopVictimSectorsPanel } from './TopVictimSectorsPanel'

export function TopVictimCountriesPanel() {
  const { data, isLoading } = useAnalyticsDecideTopVictimCountries()

  if (isLoading) {
    return (
      <div
        data-testid="top-victim-countries-loading"
        className="h-48 animate-pulse rounded-md bg-muted"
      />
    )
  }
  if (!data) return null

  if (!data.sufficient) {
    return (
      <TopVictimSectorsPanel
        sectors={data.fallbackSectors ?? []}
        isGeoFallback
      />
    )
  }

  return (
    <section className="rounded-md border border-border p-4">
      <header>
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
          Top victim countries (last 7d)
        </h2>
      </header>
      {data.buckets.length === 0 ? (
        <p className="mt-2 text-sm text-muted-foreground">
          No recent leak-site claims in the last 7 days.
        </p>
      ) : (
        <ol className="mt-3 divide-y divide-border">
          {data.buckets.map((b) => (
            <li
              key={b.countryIso2}
              className="flex items-center justify-between py-1.5 text-sm"
            >
              <span>{displayMapper.country(b.countryIso2)}</span>
              <span className="font-mono text-muted-foreground">{b.count}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  )
}
